import { Resource, ResourceRepository, ResourceTypes } from '@telespot/domain';

export interface ListResourcesInput {
  searchTerm?: string;
  limit?: number;
  lastItemName?: string;
  type?: string;
}

export interface ListResourcesOutput {
  id: string;
  name: string;
  type: string;
  description?: string;
  nestedResourcesCount: number;
}

export interface IListResourcesQuery {
  /**
   * Lists resources ordered by name, paginated by `lastItemName` cursor.
   * Each item is projected to a flat shape including the count of nested resources.
   * Repository errors propagate so the caller's pagination effect can surface them.
   */
  execute(input: ListResourcesInput): Promise<ListResourcesOutput[]>;
}

export class ListResourcesQuery implements IListResourcesQuery {
  constructor(private readonly resourceRepository: ResourceRepository) {}

  public async execute(input: ListResourcesInput): Promise<ListResourcesOutput[]> {
    const resources = await this.resourceRepository.getAll(
      input.searchTerm,
      input.limit,
      input.lastItemName,
      input.type as ResourceTypes
    );
    return resources.map((resource: Resource) => ({
      id: resource.id,
      name: resource.name,
      type: resource.type,
      description: resource.description,
      nestedResourcesCount: resource.resources?.length ?? 0,
    }));
  }
}
